import LocationObject from 'entities/locationObject/model';

export const renderAddress = (locationObject?: LocationObject) =>
  locationObject?.city
    ? [
        locationObject.address,
        locationObject.city,
        [locationObject.state, locationObject.postalCode].filter(Boolean).join(' '),
      ]
        .filter(Boolean)
        .join(', ')
    : '';
